// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
//引入字体
import './conmon/font.css'
import '@/assets/style/reset.css'
import '@/assets/style/commonStyle.css'
import '@/styles/common.less'
require("swiper/css/swiper.css")
// import '@/assets/style/rem.js'
import Nav from "./components/Nav.vue"
import Fastclick from 'fastclick'
import VueI18n from 'vue-i18n'
Fastclick.attach(document.body)
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import { Field,CellGroup,Notify,Dialog } from 'vant';
// import first from './components/first.vue'
import './filters/index'
import "babel-polyfill"
import {checkMobile} from './utils/util'

import {
  Message,
  Collapse,
  CollapseItem,
  Input,
  Radio,
  RadioGroup,
  Loading,
  Tabs,
  TabPane,
  Select,
  Option,
  Timeline,
  TimelineItem,
  Image,
  Carousel,
  CarouselItem,
  Progress,
  Form,
  FormItem,
  Button
} from 'element-ui'

router.beforeEach((to, from, next) => {
  console.log('判断拦截跳转','-------------')
  if (!checkMobile()) {
    var pathname = window.location.pathname
    var query = window.location.search;
    if(process.env.NODE_ENV == 'production' || process.env.NODE_ENV == 'prodEn'){
      window.location.href = "http://register.speediance.com" + pathname + query;
    }else{
      window.location.href = "https://www.speediance.top" + pathname + query;
    };
  }
  // chrome浏览器
  document.body.scrollTop = 0
  // firefox浏览器
  document.documentElement.scrollTop = 0
  // safari浏览器
  window.pageYOffset = 0
  next()
})
import App from './App'

// Vue.use(Tab).use(Tabs);
// import 'lib-flexible'
// element ui
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Input)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Image)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Progress)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Button)
Vue.use(VueI18n)
Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.component(Message.name, Message)
Vue.prototype.$message = Message;

//van
// Vue.use(Field)
// Vue.use(CellGroup)
// Vue.use(Notify)
// Vue.use(Radio);
// Vue.use(RadioGroup);
// Vue.use(Dialog);

// import '../node_modules/swiper/swiper.min.css'


//阻止生产模式提醒
Vue.config.productionTip = false
// Vue.component('first', first)
// Vue.component('mheader',mheader)
// Vue.component('mfooter',mfooter)
Vue.component('Nav', Nav)

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'  //引入样式(swiper5的引入css)
Vue.use(VueAwesomeSwiper)


import VueTouch from 'vue-touch'
Vue.use(VueTouch, { name: 'v-touch' })

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

import '../static/js/jsmpeg.min.js'

const i18n = new VueI18n({
  locale:localStorage.getItem('locale')?localStorage.getItem('locale'):'en', // 语言标识
  messages: {
    'zh': require('./lang/zh'),
    'en': require('./lang/en')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: {
    App
  },
  template: '<App/>',
  data: {
    weChatCode: 'https://speediance.oss-cn-shenzhen.aliyuncs.com/1625561442572gongzhonghao.jpg',
    miniProgramCode: "https://speediance.oss-cn-shenzhen.aliyuncs.com/1626337874902h5.png",
    tiktokCode: 'https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb950b4dcebeb05977dcdb70c0b4b2d139888242f4ba42c928325c9fb56496860',
  }
})



// WEBPACK FOOTER //
// ./src/main.js